export default "__VITE_ASSET__Dfo5MoBW__"